import { createContext, useContext } from 'react';

interface RegimeSelectionContextValue {
  selectedRegimeId: string | number | null;
  onSelectRegime: (regimeId: string | number) => void;
}

const RegimeSelectionContext = createContext<RegimeSelectionContextValue>({
  selectedRegimeId: null,
  onSelectRegime: () => {},
});

export const RegimeSelectionProvider = RegimeSelectionContext.Provider;
export const useRegimeSelection = (): RegimeSelectionContextValue =>
  useContext(RegimeSelectionContext);
